module.exports = __webpack_public_path__ + "static/media/name-logo-transparent.598a2478.png";